// src/hooks/useUser.js
import { getData, postData, updateData, deleteData } from "../services/apiService";

// Register user
export const registerUser = (data) => postData("/register", data);

// Login user
export const loginUser = (data) => postData("/login", data);

// Forgot password
export const forgotPassword = (data) => postData("/forgot-password", data);

// Reset password
export const resetPassword = (token, data) => updateData(`/resetpassword/${token}`, data);

// Get single user profile
export const fetchUserProfile = (id) => getData(`/get-profile/${id}`);

// Get all users (protected)
export const fetchAllUsers = () => getData("/get-users");

// Update user password (protected)
export const updateUserPassword = (id, data) => updateData(`/update-password/${id}`, data);

export const updateUserRole = (id, role) => updateData(`/update-role/${id}`, { role });

export const removeUser = (id) => deleteData(`/user/${id}`);